import { useDispatch } from "react-redux";
import { casesActions } from "configs";
import { generateId, useCurrentCase, useParams, convertDoseToMg } from "duck";
import { useCreateTabletMutation } from "requests";
import { FormValues } from "./types";

export const useCreateTablet = (patientId: number) => {
  const { id: caseId } = useParams();
  const [create] = useCreateTabletMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);
  const dispatch = useDispatch();

  return (values: FormValues) => {
    const variables = {
      medication: values.name,
      dose: convertDoseToMg(values.dose, values.doseUnit),
      tabletSize: values.tabletSize,
      numberOfTablets: values.numberOfTablets,
      labelInstructions: values.labelInstructions,
      dosage: values.dosage
    };

    if (shouldSync) {
      return create({
        variables: {
          input: {
            patient: patientId,
            ...variables
          }
        }
      }).then(({ data }) => {
        const tablet = data?.createTablet?.tablet;

        if (tablet) {
          dispatch(casesActions.addTablet({ data: tablet, _id: caseId }));
        }
      });
    }

    dispatch(
      casesActions.addTablet({
        data: {
          fakeId: generateId(),
          ...variables
        },
        _id: caseId
      })
    );
  };
};
